package empiresmp.feature.gallery.model

import empiresmp.feature.gallery.util.GalleryConstant
import kotlinx.serialization.Serializable

@Serializable
data class GalleryImage(
    val id: Long
)

val GalleryImage.url: String
    get() = "${GalleryConstant.URL}/v1/gallery/image?image_id=$id"
